module.exports = __webpack_public_path__ + "static/img/fgbg1-8.7c29f59.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-8.png
// module id = 186
// module chunks = 0